import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../utils/IDS";
import { DELETE, GET, POST } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import Cookies from "js-cookie";


// GET Auth - Login
export const GetAllNotification = createAsyncThunk(
  "notification/GetAllNotification/get",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Notification.ALL}?page=${filter?.page || IDS.PAGE}`);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const DeleteNotification = createAsyncThunk(
  "notification/DeleteNotification/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await DELETE(`${APIS.Notification.ALL}/${id}`);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetNotificationCount = createAsyncThunk(
  "notification/GetNotificationCount/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Notification.ALL + "/count");

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const Slice = createSlice({
  name: "notification",
  initialState: {
    data: {},
    count: {},
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllNotification.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllNotification.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllNotification.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetNotificationCount.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetNotificationCount.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.count = action.payload?.data || {};
      })
      .addCase(GetNotificationCount.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      ;
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
